import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'
import {
    Badge,
    Tooltip,
    IconButton,
} from '@material-ui/core'
import FilterNone from '@material-ui/icons/FilterNone'
import { Analytics, UrlManipulation } from '../../utils';

const useStyles = makeStyles(theme => ({
    iconButton: {
        justifyContent: 'center',
        marginLeft: 10,
        marginRight: 10,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            "& .MuiBadge-colorSecondary": {
                opacity: 0,
            },
        },
    },
    iconBadge: {
        "& .MuiBadge-colorSecondary": {
            backgroundColor: 'grey !important'
        },

    },
}))

const SimilarClausesButton = ({ clause }) => {
    const { t } = useTranslation()
    const classes = useStyles()

    return (
        <Tooltip
            title={t('tooltips.similar')}
            aria-label={t('tooltips.similar')}>
            <IconButton
                variant="outlined"
                className={classes.iconButton}
                onClick={event => {
                    event.stopPropagation()
                    Analytics.buttonClickEvent('Similar Clauses')
                    UrlManipulation.goToSimilarClauses(clause.clause_id)
                }}
            >
                <Badge badgeContent={clause.similar_clauses_count} color="secondary" className={classes.iconBadge}>
                    <FilterNone />
                </Badge>
            </IconButton >
        </Tooltip>
    )
}

export default SimilarClausesButton